import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_mst_label_link_RowClass} from '../../../dbschema';

export class LabelLinkContainerModel extends BaseContainerModel {
  bl_fi_mst_label_link: bl_fi_mst_label_link_RowClass = new bl_fi_mst_label_link_RowClass();
}
